<template>
  <div
    class="patrolPoint mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="sheetsContent commonOrderContent">
      <div class="formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="巡检类型">
            <el-select
              v-model="formInline.region"
              placeholder="请选择巡检点类型"
            >
              <el-option label="设备" value="DEVICE"></el-option>
              <el-option label="区域" value="REGION"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="搜索">
            <el-input v-model="formInline.name" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                currentPage = 1;
                handleSizeChange(10);
              "
              >查询</el-button
            >
          </el-form-item>
          <el-form-item
            v-if="judgeAuthority('houqinguanli:xunjianguanli:patrolPoint:edit')"
          >
            <el-button
              type="warning"
              icon="el-icon-plus"
              @click="
                editPoints = true;
                activeItem = {};
              "
              >新增巡检点</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary" plain
              v-if="
                judgeAuthority('houqinguanli:xunjianguanli:patrolPoint:export')
              "
              @click="exportExcel"
              ><i class="el-icon-download el-icon--left"></i>EXCEL</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="tabCardBox">
        <div class="orderCardItem">
          <el-table
            :data="tableData"
            stripe
            border
            style="width: 100%"
            class="tabWrap"
            height="93%"
            :header-cell-style="{
              'background-color': '#F7F7F7',
            }"
          >
            <el-table-column
              v-for="(v, i) in tabHead"
              :key="i"
              :prop="v.prop"
              :label="v.label"
              :min-width="
                v.prop == 'status' ||
                v.prop == 'deviceSize' ||
                v.prop == 'fixedDeviceSize'
                  ? 30
                  : ''
              "
              :show-overflow-tooltip="true"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope">
                <template
                  v-if="
                    judgeAuthority(
                      'houqinguanli:xunjianguanli:patrolPoint:edit'
                    )
                  "
                >
                  <el-button
                    v-if="scope.row.pointType == 'PERSONAL'"
                    @click="
                      editPoints = true;
                      activeItem = scope.row;
                    "
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    v-if="scope.row.pointType == 'PERSONAL'"
                    type="text"
                    size="small"
                    @click="deleteClick(scope.row)"
                    >删除</el-button
                  >
                </template>
                <el-button
                  type="text"
                  size="small"
                  @click="
                    qrCode = true;
                    activeItem = scope.row;
                  "
                  >二维码</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 30, 50]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            style="margin-top: 10px; text-align: right"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增编辑巡检点 -->
    <AddPatrolPoints v-if="editPoints" :activeItem="activeItem" />
    <!-- 二维码 -->
    <QrCodeCom v-if="qrCode" :activeItem="activeItem" />
  </div>
</template>

<script>
import api from "@/api";
import AddPatrolPoints from "@/components/houqinguanli/xunjianguanli/AddPatrolPoints";
import QrCodeCom from "@/components/houqinguanli/xunjianguanli/QrCodeCom";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import { judgeAuthority, exportExcelFun } from "@/assets/js/utils";
export default {
  components: {
    AddPatrolPoints,
    QrCodeCom,
  },
  data() {
    return {
      editPoints: false,
      qrCode: false,
      formInline: {
        name: "",
        region: "DEVICE",
      },
      tabHead: [],
      tableData: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      activeItem: {},
    };
  },
  methods: {
    judgeAuthority,
    deleteClick(row) {
      this.$confirm("此操作将删除该巡检点, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return new Promise(async (resolve) => {
            let res = await api.patrolPointDelete({}, row.id);
            if (res && res.data.code == 200) {
              this.$message.success("删除成功!");
              this.$store.commit("SET_LOADING", true);
              setTimeout(() => {
                this.getList();
              }, 1000);
            }
            resolve();
          });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    async getList() {
      this.tableData = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.patrolPointPageList({
        pageSize: this.page.size,
        page: this.currentPage - 1,
        name: this.formInline.name,
        type: this.formInline.region,
        sourceType: "INSPECTION",
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableData = res.data.data.data;
        this.page.total = res.data.data.totalElements;
        this.getHeader();
      }
    },
    getHeader() {
      this.tabHead = [];
      if (this.formInline.region == "DEVICE") {
        this.tabHead = [
          { label: "设备编号", prop: "id" },
          { label: "设备名称", prop: "name" },
          { label: "设备位置", prop: "location" },
          { label: "设备状态", prop: "status" },
          { label: "说明", prop: "remark" },
        ];
      } else {
        this.tabHead = [
          { label: "区域编号", prop: "id" },
          { label: "区域名称", prop: "name" },
          { label: "区域设备数量", prop: "deviceSize" },
          { label: "区域固定资产数量", prop: "fixedDeviceSize" },
          { label: "说明", prop: "remark" },
        ];
      }
    },
    exportExcel() {
      exportFile.xlsxFile(XLSX, "巡检点位", {
        excel: exportExcelFun(this.tabHead, this.tableData),
      });
    },
  },
  created() {
    this.getHeader();
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.patrolPoint {
  @include setFlexCenter;

  .sheetsContent {
    width: 98%;
    height: 96%;

    ::v-deep .el-select .el-input__inner {
      vertical-align: bottom !important;
    }

    ::v-deep .el-input--suffix .el-input__inner {
      vertical-align: bottom !important;
    }
  }
}
</style>
